import { useMemo, useState } from 'react'
import EstoqueHttp from '../../../../services/api/https/estoque/Estoque.http'
import { errorHandler } from '../../../../services/util/error.service'
import { getPeriodoMesAtual, parseToMysqlFormat } from '../../../../services/util/date.service'
import { getEmpresas } from '../../../../services/localstorage/localstorage.service'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  GET_INFORMACOES: 'Carregando informações',
}

const INITIAL_STATE = {
  periodo: getPeriodoMesAtual(),
  operacoesEstoque: [],
  empresas: getEmpresas(),
  selectedEmpresa: null,
  selectedOperacaoEstoque: null,
  operacoesEstoqueFiltered: [],
  selectedEstoque: null,
  estoquesOptions: [],
  pathToRedirect: null,
  globalFilter: '',
  loadingMessage: LOAD_MESSAGE.NONE,
  rows: [],
  errorMessage: null,
}

export default function useMovimentacaoPorTipoOperacao() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    //Helpers

    return {
      getMovimentacaoPorTipoOperacao(
        selectedTp,
        selectedGrupoOperacao,
        selectedEmpresa,
        pInicial,
        pFinal,
        selectedOperacaoEstoque,
        selectedEstoque,
      ) {
        if (!selectedEmpresa)
          setState(prevState => ({ ...prevState, errorMessage: 'Selecione uma empresa' }))
        if (!selectedGrupoOperacao)
          setState(prevState => ({ ...prevState, errorMessage: 'Selecione um tipo de operação' }))
        else if (!selectedTp)
          setState(prevState => ({ ...prevState, errorMessage: 'Selecione um TP' }))
        else {
          setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.GET_INFORMACOES }))
          EstoqueHttp.getMovimentacaoPorTipoOperacao(
            selectedTp,
            selectedGrupoOperacao.value,
            selectedEmpresa.id,
            parseToMysqlFormat(pInicial),
            parseToMysqlFormat(pFinal),
            selectedOperacaoEstoque && selectedOperacaoEstoque.length
              ? selectedOperacaoEstoque.map(item => item.id)
              : undefined,
            selectedEstoque && selectedEstoque.length
              ? selectedEstoque.map(item => item.id)
              : undefined,
          )
            .then(res =>
              setState(prevState => ({
                ...prevState,
                rows: res,
                loadingMessage: LOAD_MESSAGE.NONE,
              })),
            )
            .catch(err =>
              setState(prevState => ({
                ...prevState,
                loadingMessage: LOAD_MESSAGE.NONE,
                errorMessage: errorHandler(err),
              })),
            )
        }
      },

      //Actions

      onChange(name, value) {
        setState(prevState => {
          prevState[name] = value
          if (name === 'selectedGrupoOperacao') {
            prevState.operacoesEstoqueFiltered = prevState.operacoesEstoque.filter(
              item => item.grupo_de_operacao === value.value,
            )
            prevState.selectedOperacaoEstoque = null
            if (value.value === 'Recebimento' || value.value === 'Expedicao')
              prevState.selectedEstoque = null
            prevState.rows = []
          }
          return { ...prevState }
        })
      },

      onInit(selectedTp) {
        if (!selectedTp) setState(prevState => ({ ...prevState, errorMessage: 'Selecione um TP' }))
        else {
          EstoqueHttp.getOperacoesEstoque(selectedTp).then(res =>
            setState(prevState => {
              prevState.operacoesEstoque = res.operacoes_entrada_saida.filter(
                res => !res.belongsToTransfer,
              )
              return { ...prevState }
            }),
          )
          EstoqueHttp.getEstoques(selectedTp).then(res =>
            setState(prevState => {
              prevState.estoquesOptions = res
              return { ...prevState }
            }),
          )
        }
      },

      resetState() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: null,
        }))
      },
    }
  }, [])

  return { state, localDispatch }
}
